export const I18n = {
	'en': {
		searchPlaceholder: 'Search by name',
		delete: 'Delete',
		companyName: 'Company name'
	},
	'ru': {
		searchPlaceholder: 'Поиск по имени',
		delete: 'Удалить',
		companyName: 'Имя компании'
	},
	'sk': {
		searchPlaceholder: 'Vyhľadávanie podľa mena',
		delete: 'Vymazať',
		companyName: 'Meno spoločnosti'

	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/linkedCompaniesList/index.js